'use client';

import { Partners } from '@eliadmin/core/src/components/homepage/partners';
import { useQuery } from '@tanstack/react-query';
import { useEffect, useRef, useState } from 'react';
import { partnersQueryOptions } from '@/utils/partners-query';

export function DeferredPartners({ locale }: { locale: string }) {
  const container = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);
  const { data } = useQuery({ ...partnersQueryOptions(locale), enabled: visible });

  useEffect(() => {
    if (!container.current) return;
    if (typeof IntersectionObserver === 'undefined') {
      setVisible(true);
      return;
    }
    const observer = new IntersectionObserver(
      entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        setVisible(true);
        observer.disconnect();
      },
      { rootMargin: '300px' },
    );
    observer.observe(container.current);
    return () => observer.disconnect();
  }, []);

  return (
    <div
      ref={container}
      className="min-h-[116px] sm:min-h-[120px] md:min-h-[128px] lg:min-h-[144px]"
    >
      {/* Keep rail geometry on slow/error/empty responses. Product content never waits. */}
      {!!data?.length && <Partners partners={data} />}
    </div>
  );
}
